<template>
  <div>
    <my-header
      :page_name="$t('navigation.headerTitles.multiTask')"
      show_usermenu
    ></my-header>
    <el-dialog
      :visible.sync="showMoreFlag"
      v-if="showMoreFlag"
      width="80%"
    >
      <div class="info">
        <span class="task-line-element">{{ $t("multiTask.app") }}</span>
        <span class="task-line-element">{{ $t("multiTask.processPid") }}</span>
        <span class="task-line-element">queueId</span>
      </div>
      <div class="tasks-info started">
        <b>{{ $t("multiTask.working") }}</b>
        <div
          v-for="(queueTask, index) in startedQueueIds"
          :key="index"
          class="task"
        >
          <span class="task-line-element">{{ queueTask.appName }}</span>
          <span class="task-line-element"> {{ queueTask.pid }} </span>
          <span class="task-line-element">{{ queueTask.qId }}</span>
        </div>
      </div>
      <div class="tasks-info finished">
        <b>{{ $t("multiTask.completed") }}</b>
        <div
          v-for="(queueTask, index) in finishedQueueIds"
          :key="index"
          class="task"
        >
          <span class="task-line-element">{{ queueTask.appName }}</span>
          <span class="task-line-element"> {{ queueTask.pid }} </span>
          <span class="task-line-element">{{ queueTask.qId }}</span>
        </div>
      </div>
      <div class="tasks-info error">
        <b>{{ $t("multiTask.completedWithError") }}</b>
        <div
          v-for="(queueTask, index) in errorQueueIds"
          :key="index"
          class="task"
        >
          <span class="task-line-element">{{ queueTask.appName }}</span>
          <span class="task-line-element"> {{ queueTask.pid }} </span>
          <span class="task-line-element">{{ queueTask.qId }}</span>
        </div>
      </div>
      <div>
        {{ $t("multiTask.infoAboutThisTaskYouCanSeeInStatus") + "." }}
        <br />{{ $t("multiTask.currentPackageComment") }}
        <b>{{ lastComment }}</b>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showBusy" v-if="showBusy" width="80%" :title="$t('multiTask.busyTasks')">
      <div v-for="(busyEntry, index) in busyObject" :key="index" class="server-line">
        {{$t('runTask.server')}} <b>{{ busyEntry.serverName }}</b>:
        <div v-for="app in busyEntry.app" :key="app.appId" class="app-line">
          &#8729;  {{$t('multiTask.app')}}: {{ app.appName }}
          <span v-if="app.appAlias">({{ app.appAlias }})</span>
        </div>
        <div v-for="upg in busyEntry.upg" :key="upg.taskNN" class="upg-line">
          &#8729; {{$t('multiTask.upgrade')}}: {{ upg.taskParams }}
        </div>
        <el-divider></el-divider>
      </div>
    </el-dialog>
    <div class="settings-line">
      <div v-if="upgTasks && upgTasks.length > 1" class="settings-element">
        <label>{{ $t("multiTask.task") + ":" }}</label>
        <el-select v-model="taskSelected" @change="taskChanged" filterable>
          <el-option
            v-for="(task, index) in upgTasks"
            :key="index"
            :value="task.id"
            :label="task.caption"
          ></el-option>
        </el-select>
      </div>
      <div class="settings-element">
        <div>
          <el-upload
            action
            ref="upgInput"
            :auto-upload="false"
            :limit="1"
            accept=".upg"
            :on-change="handleUpgUpload"
          >
            <el-button slot="trigger">{{
              $t("multiTask.fileSelect")
            }}</el-button>
          </el-upload>
        </div>
      </div>
      <!-- <div class="settings-element">
        <el-button v-if="!!upgFile" @click="addFileClick" size="mini">Прикрепить файл (опционально)</el-button>
      </div>-->
    </div>
    <div v-if="lastComment && startedQueueIds.length > 0">
      {{
        $t("multiTask.youRun") +
        " " +
        checkedArray.length +
        " " +
        $t("multiTask.tasks") +
        "." +
        " " +
        $t("multiTask.successfully")
      }}
      &mdash; {{ queueIdsStartedParsed.length }}.
      <el-button @click="showMore">{{ $t("multiTask.moreDetails") }}</el-button>
      <el-button @click="clearResults">{{
        $t("multiTask.clearResults")
      }}</el-button>
    </div>
    <div class="main-task-container" v-if="!!upgFile">
      <div class="main-task-tree-container">
        <el-button @click="uncheckTree" type="plain" class="clear-button">{{
          $t("multiTask.clear")
        }}</el-button>
        <el-button @click="sendClick" class="start-button" type="primary">{{
          $t("multiTask.start")
        }}</el-button>
        <tree style="max-height: 70vh;"></tree>
      </div>
      <presets></presets>
    </div>
  </div>
</template>

<script>
import Header from "../../components/reusable/header/Header";
import Tree from "../../components/common/mapTree/Tree";
import MultiTaskPresets from "../../components/tasks/MultiTaskPresets";
import parseZombiesMixin from "../../components/tasks/parseZombiesMixin";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      taskSelected: null,
      fileDialog: false,
      upgFile: null,
      tmpComment: null,
      lastComment: null,
      showMoreFlag: false,
      busyObject: null,
      showBusy: false,
      // additionalFile: null,
    };
  },
  methods: {
    taskChanged() {
      this.$store.commit("setTaskId", this.taskSelected);
    },
    handleUpgUpload() {
      this.$store.commit("setLoading", true);
      this.upgFile = this.$refs.upgInput.uploadFiles[0].raw;
      this.tmpComment = null;
      this.lastComment = null;
      this.$store
        .dispatch("getUpgTree", this.upgFile.name)
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("setLoading", false);
        });
    },
    sendClick() {
      //   var idArray = [];
      this.$store.commit("setCheckedArray");
      // console.log(this.checkedArray);
      if (this.checkedArray.length === 0) {
        this.$store.commit(
          "setError",
          this.$t("multiTask.noAppsSelectedError")
        );
        return;
      }
      let checkedIds = [];
      for (let idArray of this.checkedArray) {
        checkedIds.push(`${idArray[1]}`);
      }
      let comment = "";
      this.$prompt(this.$t("multiTask.enterStartMessage"), {
        confirmButtonText: this.$t("multiTask.enter"),
        cancelButtonText: this.$t("multiTask.cancellation"),
      })
        .then(({ value }) => {
          if (value) comment = value.trim();
          else comment = "";
          let time = moment.utc().format("HHmmss");
          // console.log(time);
          comment += " " + time;
          let objectToServer = {
            cmd: "luaFunc",
            params: {
              script: "multirunupg",
              funcname: "mrun",
              funcparam: {
                body: `'[$$]${this.upgFile.name}'`,
                idTask: this.selectedTaskId,
                idSections: checkedIds,
                comment,
              },
            },
          };
          // console.log(objectToServer);
          const formData = new FormData();
          const commandStr = JSON.stringify(objectToServer);
          formData.append("command", commandStr);
          formData.append("upload", this.upgFile);
          this.$store.commit("setLoading", true);
          this.tmpComment = comment;
          this.$store
            .dispatch("runMultiUpg", formData)
            .then(({ clean }) => {
              this.$store.commit("setLoading", false);
              this.upgFile = null;
              this.lastComment = this.tmpComment;
              const input = this.$refs.upgInput;
              input.clearFiles();
              this.parseZombies(clean);
            })
            .catch((error) => {
              this.$store.commit("setLoading", false);
              if (error.clean && error.busy) {
                this.parseZombies(error.clean);
                this.busyObject = error.busy;
                this.showBusy = true;
              } else {
                console.error(error);
              }
            });
        })
        .catch(() => {});
    },
    uncheckTree() {
      this.$store.commit("uncheckTree");
    },
    showMore() {
      this.showMoreFlag = true;
      this.$store.dispatch("updateMultiStatus").catch((error) => {
        console.error(error);
      });
    },
    clearResults() {
      this.lastComment = null;
      this.$store.commit("updateStartedQueueIds", []);
      this.$store.commit("updateFinishedQueueIds", []);
      this.$store.commit("updateErrorQueueIds", []);
    },
  },
  created() {
    // this.$store.commit("setLoading", true);
    this.$store.dispatch("getUpgTasks").then(() => {
      this.$store.commit("setShowCheckboxes", true);
      // console.log("upgTasks ", this.upgTasks);
      if (this.upgTasks.length === 1) {
        this.$store.commit("setTaskId", this.upgTasks[0].id);
      }
    });
  },
  destroyed() {
    this.$store.commit("setShowCheckboxes", false);
  },
  computed: {
    ...mapGetters([
      "multitree",
      "selectedTaskId",
      "upgTasks",
      "checkedArray",
      "startedQueueIds",
      "finishedQueueIds",
      "errorQueueIds",
      "getUser"
    ]),
    queueIdsStartedParsed() {
      let array = [];
      this.startedQueueIds.forEach((qTask) => {
        let parse = parseInt(qTask.qId);
        if (isNaN(parse)) {
          //если там было не число
          this.$store.commit("setError", qTask.qId);
        } else {
          array.push(qTask.qId);
        }
      });
      return array;
    },
  },
  mixins: [parseZombiesMixin],
  components: {
    myHeader: Header,
    Tree,
    Presets: MultiTaskPresets,
  },
};
</script>

<style scoped>
.main-task-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 20px;
}
.main-task-tree-container {
  flex-grow: 1;
}
.start-button {
  margin-left: 10px;
  margin-top: 10px;
  margin-bottom: 5px;
}
.clear-button {
  margin-left: 5px;
  margin-bottom: 5px;
}
.run-upg-button {
  margin-bottom: 30px;
  transform: scale(1.2);
  margin-left: 34px;
  margin-top: 10px;
}
.info {
  font-style: italic;
  margin: 10px;
}
.tasks-info {
  margin: 10px;
}
.task-line-element {
  display: inline-block;
  width: calc((80vw - 200px) / 3);
  padding: 0px 10px;
}
.tasks-info.error {
  color: darkred;
}
.tasks-info.finished {
  color: darkgreen;
}
.tasks-info .task::before {
  content: "\2022";
}

.server-line{
  margin-left: 20px;
}
.app-line{
  margin-left: 10px;
}
.upg-line{
  margin-left: 10px;
}
</style>